let userActionsDict = {
  "event": "userActions",
  "lead_id": '',
  "duration": 0,
  "click": 0,
  "touch": 0,
  "wheel": 0,
  "move": 0
}

function resetUserActions () {
  for (let key in userActionsDict) {
    if (["event", "lead_id"].indexOf(key) == -1) {
      userActionsDict[key] = 0
    }
  }
}

function initActionsLIsteners () {
  let timeoutMouse
  document.onmousemove = function () {
    clearTimeout(timeoutMouse);
    timeoutMouse = setTimeout(function () {
      userActionsDict["move"] += 1;
    }, 500);
  };
  let timeoutTouch
  document.ontouchmove = function () {
    clearTimeout(timeoutTouch);
    timeoutTouch = setTimeout(function () {
      userActionsDict["move"] += 1;
    }, 500);
  };
  document.onwheel = function () {
    userActionsDict["wheel"] += 1;
  };
  document.onclick = function () {
    userActionsDict["click"] += 1;
  };
  document.ontouchstart = function () {
    userActionsDict["touch"] += 1;
  };
}

// collect timing data for Dasha for each input
let timing_fields = {};
let historyToDataLayer = [];

let enterField_timing = function (name) {
  timing_fields[name] = new Date().getTime();
  let hL = historyToDataLayer.length
  if (hL) {
    if (historyToDataLayer[hL - 1][0] === name) {
      // field already in history || previous field handler not ended
    } else if (historyToDataLayer[hL - 1][1] === '-') {
      leaveField_timing(historyToDataLayer[hL - 1][0])
      historyToDataLayer.push([name, '-'])
    } else {
      historyToDataLayer.push([name, '-'])
    }
  } else {
    historyToDataLayer.push([name, '-'])
  }
}

let leaveField_timing = function (name, type) {
  let timeSpent;
  if (timing_fields.hasOwnProperty(name)) {
    timeSpent = new Date().getTime() - timing_fields[name];
    if (timeSpent > 0 && timeSpent < 1800000) {
      // window.dataLayer = window.dataLayer || [];
      // window.dataLayer.push({
      //   'event': 'fieldTiming',
      //   'timingCategory': 'Crezu Form Field Timing',
      //   'timingVariable': name,
      //   'timingLabel': type,
      //   'timingValue': timeSpent / 1000,
      //   'lead_id': localStorage.getItem('leadId')
      // });
      if (historyToDataLayer.length) historyToDataLayer[historyToDataLayer.length - 1][1] = timeSpent / 1000
    }
    delete timing_fields[name];
  }
}

function fieldsTimingInit () {
  let initHandler = function (input, event) {
    let inputType = input.attr('type')
    input.on(event, function () {
      if ((!input.attr("is-new-select") / 1) && (inputType !== 'checkbox') && (inputType !== 'radio') && (inputType !== 'disabled')) {
        if (event === 'focus') {
          enterField_timing(input.attr('name'))
        } else {
          leaveField_timing(input.attr('name'), event);
        }
      }
    })
  }
  $('input').each( function () {
    initHandler($(this), 'focus')
    initHandler($(this), 'change')
    initHandler($(this), 'blur')
  })
  // events for customSelect find in handlers onChange and onFocus
}

export {
  userActionsDict, historyToDataLayer, resetUserActions, initActionsLIsteners, enterField_timing,
  fieldsTimingInit, leaveField_timing
}